import axios from "axios";

const getBaseUrl = () => {
  const envBase = process.env.REACT_APP_API_BASE_URL;
  if (envBase) return envBase.replace(/\/$/, "");
  return window.location.origin;
};

const api = axios.create({
  baseURL: `${getBaseUrl()}/api/`,
  withCredentials: true,
  xsrfCookieName: "netdefenders_csrf_token",
  xsrfHeaderName: "x-netdefenders-csrf-token",
});

let accountMeInFlight = null;
let accountMeCache = null;
let accountMeCacheAt = 0;
const ACCOUNT_ME_CACHE_MS = 2000;

export const getAccountMeCached = (config = {}) => {
  const now = Date.now();
  if (accountMeCache && now - accountMeCacheAt < ACCOUNT_ME_CACHE_MS)
    return Promise.resolve(accountMeCache);
  if (accountMeInFlight) return accountMeInFlight;

  accountMeInFlight = api
    .get("/account/me", config)
    .then((res) => {
      accountMeCache = res;
      accountMeCacheAt = Date.now();
      return res;
    })
    .finally(() => {
      accountMeInFlight = null;
    });

  return accountMeInFlight;
};

const getCookie = (name) => {
  const parts = `; ${document.cookie}`.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(";").shift() : undefined;
};

api.interceptors.request.use((config) => {
  if (!config.headers) config.headers = {};
  const xsrfToken = getCookie("netdefenders_csrf_token");
  if (xsrfToken) config.headers["x-netdefenders-csrf-token"] = xsrfToken;
  return config;
});

let isRefreshing = false;
let refreshSubscribers = [];
const subscribeTokenRefresh = (cb) => refreshSubscribers.push(cb);
const notifyRefreshSubscribers = (error) => refreshSubscribers.forEach((cb) => cb(error));

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest?._retry) {
      originalRequest._retry = true;
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          await api.post("/refresh");
          isRefreshing = false;
          notifyRefreshSubscribers(null);
          refreshSubscribers = [];
          return api(originalRequest);
        } catch (refreshError) {
          isRefreshing = false;
          notifyRefreshSubscribers(refreshError);
          refreshSubscribers = [];
          const where = encodeURIComponent(window.location.pathname + window.location.search);
          window.location.href = `/portal/authentication/sign-in?redirect=${where}`;
          return Promise.reject(refreshError);
        }
      }
      return new Promise((resolve, reject) => {
        subscribeTokenRefresh((refreshError) => {
          if (refreshError) return reject(refreshError);
          return resolve(api(originalRequest));
        });
      });
    }
    return Promise.reject(error);
  }
);

export default api;
